(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.customer.show.project.granularity-dashboard', {
      url: '/granularity-dashboard',
      template: `<new-front-container path="'granularity-dashboard'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.granularity-dashboard" | translate}}',
      },
    });
  }
})();
